import { makeStyles } from '@material-ui/core/styles';

export default makeStyles({
  avatar: {
    borderRadius: '0.5rem',
  },
});
